import { Form, Input, message } from "antd";
import React from "react";
import { Api } from "../../../../../api/configApi";
import Boton from "../../../../../components/design/elementos/boton";

function IntegracionCoinApi(props) {
  const [form] = Form.useForm();
  function guardar(values) {
    Api(
      "Cuentas",
      "InsertIntegracion",
      { tipoIntegracion: "conversionMonedas", proveedor: "CoinApi" },
      values
    ).then((res) => {
      if (res.success) {
        message.success("Integración CoinApi guardada");
      } else {
        message.error("Algo no salio bien.");
      }
    });
  }

  React.useEffect(() => {
    form.setFieldsValue(props.integraciones?.CoinApi)
  }, [props.integraciones]);
  return (
    <Form form={form} onFinish={guardar} layout="vertical">
      <Form.Item
        rules={[{ required: true, message: "campo obligatorio" }]}
        label="Api Key"
        name="apiKey"
      >
        <Input />
      </Form.Item>
      <Boton texto="Guardar" htmlType="submit" />
    </Form>
  );
}

export default IntegracionCoinApi;
